import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { UserPostAddService } from "./user-post-add.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-user-post-add",
  templateUrl: "./user-post-add.component.html",
  styleUrls: ["./user-post-add.component.sass"],
})
export class UserPostAddComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private userPostAddService: UserPostAddService,
    private router: Router,
  ) {}
  allPosts: any[] = [];
  itemsPerPage: number = 6;
  totalItems: number = 0;
  page: number = 1;

  ngOnInit(): void {
    this.getAllUserPosts(1);
  }

  getAllUserPosts(page: any) {
    this.spinner.show();
    const data = {
      limit: this.itemsPerPage,
      page: page,
    };
    this.userPostAddService.getUserPosts(data).subscribe({
      next: (result: any) => {
        if (result.statusCode === 200) {
          this.allPosts = result.data;
          this.totalItems = result.pagination?.total || 0;
        } else {
          this.toastr.error(result.message || "Something went wrong");
        }
      },
      error: (err) => {
        this.toastr.error("API Error");
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }

  deleteData(data: any) {
    this.spinner.show();
    let id = data._id;
    this.userPostAddService.delete(id).subscribe({
      next: (result: any) => {
        if (result.statusCode === 200) {
          this.toastr.success(result.message);
          this.getAllUserPosts(this.page);
        } else {
          this.toastr.error(result.message || "Something went wrong");
        }
      },
      error: (err) => {
        this.toastr.error("API Error");
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }
  viewLoad(data: any) {
    // this.router.navigate(["dashboard/load"], {
    //   queryParams: { id: data._id },
    // });
  }

  viewBids(data: any) {
    this.router.navigate(["dashboard/bids"], {
      queryParams: { id: data._id, type: "load" },
    });
  }
}
